import { ReportGraphPointDto } from './report-graph-point.dto';

export class ReportGraphPoint {
    /** First day of the bucket `YYYY-MM-DD` — the day, the week's Monday or the month's 1st. */
    readonly date: string;
    readonly scanCount: number;
    readonly placedCartonCount: number;
    readonly closedCartonCount: number;
    readonly closedPalletCount: number;
    /** Nothing sorted, placed or closed in the bucket. */
    readonly idle: boolean;

    constructor(dto: ReportGraphPointDto) {
        this.date = dto.date;
        this.scanCount = dto.scanCount;
        this.placedCartonCount = dto.placedCartonCount;
        this.closedCartonCount = dto.closedCartonCount;
        this.closedPalletCount = dto.closedPalletCount;
        this.idle = !dto.scanCount && !dto.placedCartonCount && !dto.closedCartonCount && !dto.closedPalletCount;
    }
}
